// removed by extract-text-webpack-plugin
module.exports = {"linkBlue":"#0076C0","borderGray":"#d9d9d9","small":"only screen and (min-width: 481px)","medium":"only screen and (min-width: 768px)","container":"container-34RLT","closeButton":"closeButton-1LPNj","title":"title-22aYU","description":"description-2VVQb","controls":"controls-1WPgN","button":"button-33Rgb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/auth/signup/_onboardingModal.css
// module id = 1184
// module chunks = 1